import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';

const styles = {
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
};

class AudienceSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeStep: props.activeStep,
      onChange: (e) => props.onChange(e)
    };
  }

  handleNext = () => {
    this.state.onChange(this.state.activeStep + 5)
    this.setState(state => ({
      activeStep: state.activeStep + 5,
    }));
  };

  handleBack = () => {
    this.state.onChange(this.state.activeStep - 5)
    this.setState(state => ({
      activeStep: state.activeStep - 5,
    }));
  };

  componentDidUpdate(prev) {
    if (this.props.activeStep !== prev.activeStep) {
      this.setState({ activeStep: Math.floor(this.props.activeStep) })
    }
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <MobileStepper
        variant="progress"
        steps={100}
        position="static"
        activeStep={this.state.activeStep}
        style={{ backgroundColor: 'transparent' }}
        className={classes.root}
        nextButton={
          <Tooltip title="More Customers">
            <Button variant='outlined' style={this.state.activeStep >= 100 ? { backgroundColor: 'var(--data-delivers-green)' } : {}} size="small" onClick={this.handleNext} disabled={this.props.disabled || this.state.activeStep >= 100}>
              {theme.direction !== 'rtl' ? "Customers" : "Propspects"}
              <br />
              {this.state.activeStep + '%'}
            </Button>
          </Tooltip>
        }
        backButton={
          <Tooltip title="More Prospects">
            <Button variant='outlined' style={this.state.activeStep <= 0 ? { backgroundColor: 'var(--data-delivers-green)' } : {}} size="small" onClick={this.handleBack} disabled={this.props.disabled || this.state.activeStep <= 0}>
              {theme.direction === 'rtl' ? "Customers" : "Propspects"}
              <br />
              {(100 - this.state.activeStep) + '%'}
            </Button>
          </Tooltip>
        }
      />
    );
  }
}

AudienceSlider.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(AudienceSlider);


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/selectionMenu/components/AudienceSlider.jsx